/** Телефон/планшет: на iPadOS 13+ UA как у Mac, отличаем по touch. */
export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') {
    return false
  }

  const ua = navigator.userAgent

  if (/Android|iPhone|iPad|iPod/i.test(ua)) {
    return true
  }

  return /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1
}
